import React, { useMemo } from 'react'
import { withRouter } from 'react-router'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import { ContentBlock } from 'components/ContentBlock'
import { DataTable } from 'components//DataTable'
import Button from 'components/Button'
import useLocale from 'hooks/useLocale'

import { users } from '../tableColumns'
import useClosingSum from '../hooks/useClosingSum'

const Users = ({ data, history, listQueryRef }) => {
	const [t] = useTranslation()
	const locale = useLocale()
	const cols = useMemo(() => users(t, locale), [locale])
	const { toggleSum, isSum, loading, data: sumData } = useClosingSum({ variables: listQueryRef.current.variables })

	const gotoUser = (_, { original: closingUser }) => {
		const userId = get(closingUser, ['user', 'id'])
		if(userId) {
			history.push(`/benutzer/${userId}`)
		}
	}

	return(
		<ContentBlock>
			<Button
				text={t('product_section.strings.sum')}
				status={isSum ? 'green' : 'primary'}
				onClick={toggleSum}
			/>
			<DataTable
				loading={loading}
				isInsideContentBlock
				columns={cols}
				data={(isSum ? sumData.users : data.users) || []}
				withColFilter
				label={t('closing_section.sub_sections.user')}
				onRowClick={gotoUser}
			/>
		</ContentBlock>
	)
}

export default withRouter(Users)
